import { subDays, today } from '../../../../utils/date';

const rootNode = document.getElementById('finance-landing-page-root');

// The rolling lag the backend applies when the user has no cutoff permission.
export const defaultCutoffDate = subDays(today(), 4);
// min(today - 4 days, cutoff date) from the backend
export const advancedCutoffDate = rootNode?.dataset?.advancedCutoffDate || defaultCutoffDate;
// An attribute equal to the rolling 4-day lag means no real user cutoff
export const hasUserCutoff = advancedCutoffDate !== defaultCutoffDate;
